import React from "react"
import { Pressable, View, Text, Image } from "react-native"

import { PrimaryCTA, SecondaryCTA } from "../CommonCTA"

import AppStyles from "../../../AppStyles"
import TextStyle from "../../../TextStyle"
import AppTheme from "../../../AppTheme"
import { IndiaRupee } from "../../constants/AppConstants"
import { ScreenRoute } from "../../constants/ScreenRouteConstant"
import { getDealPicture, getDealPicturesList, getDealSavingPercent, getDealDataForCart } from "../../services/inventory/DealsUtils"
import { UpsertCartItemView } from "../UpsertCartItemView"
import { getImagePath } from "../../services/CommonUtils"

export const NoCategoryFilterDealView = (props) => {
    let category = props.category
    let subCategory = props.subCategory
    let title = 'Couldn\'t find item'
    let subTitle = 'The store don\'t have any item.'
    if (subCategory && subCategory.name)
        title = 'Couldn\'t find \'' + subCategory.name + '\''
    if (category && category.name)
        subTitle = 'The store don\'t have this item in \'' + category.name + '\'.'
    return <View style={[AppStyles.py16, AppStyles.appWidth, AppStyles.alignCenter]}>
        <Text style={[TextStyle.text18xb]}>{title}</Text>
        <Text style={[TextStyle.text16b, TextStyle.colorGrey, TextStyle.alignCenter, AppStyles.mx24, AppStyles.mt16]}>
            {subTitle}</Text>
    </View>
}

export const NoSearchedDealView = (props) => {
    let deal = props.manualDeal
    let category = props?.category
    let searchWord = props?.searchWord
    let updateCartDealItem = props.updateCartDealItem
    return <View key={'dea view: ' + props?.from + '_index_' + deal.n}
        style={[AppStyles.flexRowStart, AppStyles.bgWhite,
        AppStyles.py16, AppStyles.pl16, { width: AppTheme.appWidth, paddingRight: 30, marginBottom: 1 }]}>

        <Image source={{ uri: getImagePath('/images/deals/noDealImage.png') }}
            style={[AppStyles.border4, { width: 90, height: 90 }]} />

        <View style={[AppStyles.ml16,
        { alignItems: "flex-start", width: AppTheme.appWidth - (90 + 32 + 30) }]}>

            <Text style={[TextStyle.text14b, TextStyle.flexWrap, TextStyle.alignLeft]}
                numberOfLines={2} ellipsizeMode={'head'}>{deal.n}</Text>

            {deal.psl ? <Text style={[TextStyle.text12, TextStyle.alignLeft, {
                marginTop: 6, color: AppTheme.color.grey.text
            }]} numberOfLines={1} ellipsizeMode={'head'}>{deal.psl}</Text> : null}

            <View style={[AppStyles.mt8, AppStyles.mb16, AppStyles.flexRowStart]}>
                <Text style={[TextStyle.text14b]}>
                    {IndiaRupee}{deal['rp'] ? deal['rp'] : '--'}</Text>
                {deal['rp'] && deal['mrp'] && deal['rp'] != deal['mrp'] ? <Text
                    style={[TextStyle.text12, TextStyle.lineThrough, TextStyle.alignCenter,
                    { marginLeft: 4, color: AppTheme.color.grey.fillerInfo }]}>
                    {IndiaRupee} {deal['mrp']}</Text> : null}
                {!!getDealSavingPercent(deal) ? <Text style={[TextStyle.text12b, { marginLeft: 4, color: AppTheme.color.green.primary }]}>
                    {getDealSavingPercent(deal)}</Text> : null}
            </View>

            {deal.quantity ? <UpsertCartItemView updateCartItem={updateCartDealItem}
                key={'deal_quan_' + deal.dealId} viewStyle={{ marginVertical: 2 }}
                item={deal} /> :
                <SecondaryCTA action={() => updateCartDealItem(true, deal)}
                    title={'Add To Cart'} width={115} key={'deal_cta_' + deal.dealId}
                    paddingVertical={6} marginAuto={false} borderWidth={1} />}
        </View>
    </View>
}


// export const NoSearchedDealView = (props) => {
//     let action = props.action
//     let category = props.category
//     let searchWord = props.searchWord
//     let title = 'Couldn\'t find \'' + searchWord + '\''
//     let subTitle = 'The store don\'t have this item. Add manually to bag'
//     if (category && category.name)
//         subTitle = 'The store don\'t have this item in \'' + category.name + '\'. Add manually to bag'
//     return <View style={[AppStyles.py16, AppStyles.appWidth, AppStyles.alignCenter]}>
//         <Text style={[TextStyle.text18xb]}>{title}</Text>
//         <Text style={[TextStyle.text16b, TextStyle.colorGrey, TextStyle.alignCenter, AppStyles.mx24, AppStyles.mt16]}>
//             {subTitle}</Text>
//         <PrimaryCTA title={'Add ' + searchWord} action={action}
//             width={164} marginVertical={16} />
//     </View>
// }